const $inject = ['$location', '$rootScope', '$q', '$http', '$filter', '$interval', 'Upload', 'hotelsService', 'hotelTagService'];

const lbaHotelCtrl = function ($location, $rootScope, $q, $http, $filter, $interval, Upload, hotelsService, hotelTagService) {
  let vm = this;

  vm.blobUrl = blobUrl;
  vm.tag = { Name: 'Any' };
  vm.page = 1;
  vm.pageSize = 50;
  vm.searchRefine = '';
  vm.resultsFiltered = false;
  vm.tab = 'iata';
  vm.IATA = {
    Iata: 'SYD',
    Name: 'Sydney (Kingsford Smith) Airport',
    CityLatitude: -33.861481,
    CityLongitude: 151.205475
  };
  vm.radiusOptions = [
    {km: 2},
    {km: 5},
    {km: 10},
    {km: 15},
    {km: 25},
    {km: 50},
    {km: 100}
  ];
  vm.tags = [{ Name: 'Any' }, ...hotelTagService.get()];
  vm.modalTab = 'images';
  vm.imageViewerActive = false;
  vm.showImageViewer = showImageViewer;
  vm.radius = vm.radiusOptions[2];
  vm.resultsName = [];
  vm.fileUploadState = { success: null, error: null, uploading: null };
  vm.getHotels = getHotels;
  vm.refreshIATA = refreshIATA;
  vm.getNumber = getNumber;
  vm.updatePage = updatePage;
  vm.changeTab = changeTab;
  vm.convert = convert;
  vm.disableHotel = disableHotel;
  vm.mergeHotel = mergeHotel;
  vm.refreshName = refreshName;
  vm.getHotelById = getHotelById;
  vm.editHotel = editHotel;
  vm.upload = upload;
  vm.getHotelByExternalId = getHotelByExternalId;
  vm.getHotelsByTag = getHotelsByTag;

  $rootScope.$on('hotelsService.mergeSuccess', function () {
    getHotels(false, true);
  });

  function getHotels(resetPage, updateResults) {
    vm.page = resetPage ? 1 : vm.page;

    if (!updateResults) {
      vm.loading = true;
      vm.hotels = [];
    }

    var apiURL;

    if(vm.tab === 'tags') {

      apiURL = `${endPointUrl}/api/v2/Hotels/GetReportByTag/${vm.tag.Name}?page=${vm.page}&size=${vm.pageSize}`;
    } else {
      if (!vm.IATA) {
        return false;
      }

      var lat = vm.IATA.CityLatitude ? vm.IATA.CityLatitude : vm.IATA.Latitude;
      var long = vm.IATA.CityLongitude ? vm.IATA.CityLongitude : vm.IATA.Longitude;
      
      apiURL = `${endPointUrl}/api/v2/Hotels/GetRadiusReport/${lat}/${long}/${vm.radius.km}?page=${vm.page}&size=${vm.pageSize}`;
    }

    $http.get(apiURL)
      .then(function (res) {
        let data = res.data.Result;
        vm.loading = false;
        vm.hotels = data.Hotels;
        vm.page = data.Page;
        vm.pages = vm.getNumber(data.NumberPages);
        vm.resultPages = data.NumberPages;
        vm.numberHotels = data.NumberHotels;
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  function refreshIATA(searchText) {
    if (searchText.length > 2) {
      $http.get(`${endPointUrl}/api/v2/Airports/SearchByIataCode?iataCode=${searchText}`)
      .then(function (res) {
        let data = res.data;
        vm.resultsIATA = data;
      })
      .catch(function (err) {
        console.log(err);
      });
    }
  }

  function getNumber(num) {
    return new Array(num);
  }

  function updatePage(index) {
    if (index <= 0 || vm.loading) {
      return false
    }
    vm.page = index;
    vm.getHotels();
  }

  function changeTab(action) {
    vm.modalTab = action;
  }

  function convert(str) {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }

  function showImageViewer(url) {
    vm.imageViewerActive = true;
    vm.imageViewerUrl = url
  }

  function disableHotel(hotel) {
    hotelsService.disableHotel(hotel);
  }

  function mergeHotel(hotel) {
    hotel.showMore = false;
    hotelsService.addHotel(hotel)
  }

  function getHotelById(hotelId) {
    $http.get(`${endPointUrl}/api/v2/Hotels/getHotelById/${hotelId}`)
      .then(function (res) {
        let data = res.data.Result;
        vm.IATA = undefined;
        vm.loading = false;
        vm.hotels = [data];
        vm.page = 1;
        vm.pages = [{}];
        vm.resultPages = 1;
        vm.numberHotels = 1;
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  function refreshName(searchText) {    
    $http.get(`${endPointUrl}/api/v2/Hotels/SearchByName?name=${searchText}&maxRows=${15}`)
      .then(function (res) {
        let data = res.data;
        vm.resultsName = data;
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  function editHotel(id) {
    window.open(`#/hotels/edit/${id}`, '_blank');
  }

  function upload(file) {
    vm.fileUploadState.uploading = true;

    Upload.upload({
      url: `${endPointUrl}/api/Upload/EventsAirHotelUpload?filename=${file.name}`,
      data: {file: file}
    }).then(function (resp) {
      console.log('SUCCESS resp: ', resp);
      vm.fileUploadState = { success: true, error: null, uploading: false };
    }, function (resp) {
      console.log('SUCCESS resp: ', resp);
      vm.fileUploadState = { success: null, error: true, uploading: false };
      console.log('Error status: ' + resp.status);
    }, function (evt) {
      console.log('evt: ', evt);
    });
  }

  function getHotelByExternalId(id) {
    $http.get(`${endPointUrl}/api/v2/Hotels/HotelsByExternalIds?ids=${id}`).then(res => {
      vm.resultsName = res.data.Result;
    });
  }

  function getHotelsByTag(tag) {
    vm.tag = tag;
    getHotels(true, false);
  }

  vm.getHotels();
};

lbaHotelCtrl.$inject = $inject;

export default lbaHotelCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaHotel/lbaHotelCtrl.js